module.exports = __webpack_public_path__ + "img/logo-icon.475edbf9.png";